import {
  addressBookEntriesDataSelector,
  addressBookEntriesLoadingSelector,
} from '../../redux/addressBook/selectors';

export default (state) => ({
  addressBookEntries: addressBookEntriesDataSelector(state),
  isLoading: addressBookEntriesLoadingSelector(state),
});
